import React, { Component } from "react";
import { LocalStorageService, SignerService, ClientDocument } from "../../../services";
import { UploadIdentityDocumentView } from "../../views";
import { useTranslation } from "react-i18next";

class UploadIdentityDocumentAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoadingView: false,
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            showWarningRequesting: false,
            messageError: '',
            messageComplete: '',
            messageWarning: '',
            documents: [],
            selectedFile: null,
            errorFile: false,
            selectedFileBase64: "",
            colorBorderContainer: "gray"
        }
    }

    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService()
    signerService = new SignerService(this.url);
    clientDocument = new ClientDocument(this.url);

    token = ''
    signRequestId = ''
    user = {}

    componentDidMount = async () => {
        let messageError = this.props.t("uploadIdentityDocument.errors.component.did.mount")
        this.toggleLoadingView(true)
        try {
            let urlArr = window.location.href.split("/");
            this.signRequestId = urlArr[urlArr.length - 1];
            this.token = this.localStorageService.getLocalStorageItem("token").idToken;
            this.user = this.localStorageService.getLocalStorageItem("user")
            this.getClientDocumentsToSigner()
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, "/")
        }
    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoadingView: value
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showErrorRequesting: true,
            messageError: message || ''
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                    messageError: ''
                })
                if (sendInbox) {
                    this.props.history.push(sendTo)
                }
            }, time || 4000)
        })
    }

    toggleCompletedRequesting = (time, sendInbox, path, message) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showCompletedRequesting: true,
            messageComplete: message || ''
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                    messageComplete: ''
                })
                if (sendInbox) {
                    this.props.history.push(sendTo)
                }
            }, time || 4000)
        })
    }

    toggleWarningRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showWarningRequesting: true,
            messageWarning: message || ''
        }, () => {
            setTimeout(() => {
                this.setState({
                    showWarningRequesting: false,
                    messageWarning: ''
                })
                if (sendInbox) {
                    this.props.history.push(sendTo)
                }
            }, time || 4000)
        })
    }


    getClientDocumentsToSigner = async () => {
        let messageError = this.props.t("uploadIdentityDocument.errors.get.documents")
        let ENV = process.env

        try {
            let clientDocuments = await this.clientDocument.getClientDocumentA3Cloud(null, this.token, this.signRequestId);
            if (clientDocuments && clientDocuments.data && Number(clientDocuments.status) === 200 && clientDocuments.data.data && Number(clientDocuments.data.statusCode) === 200) {
                let documents = clientDocuments.data.data.filter(doc => doc.keyDocument === ENV.REACT_APP_PERSON_TYPE_SIGNERS_KEY)
                documents = documents.map((doc) => {
                    doc.name = (doc.clientDocumentTypeRequestId === Number(ENV.REACT_APP_TYPE_DOCUMENT_REQUEST_OBLIGATORY)) ? `${doc.name} *` : doc.name
                    doc.status = this.props.t("uploadIdentityDocument.documents.status.pending")
                    doc.file = null
                    doc.url = ''
                    return doc
                })
                this.setState({
                    documents
                })
                this.toggleLoadingView(false)
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, true, "/")
            }
        } catch {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, "/")
        }
    }

    pdfToBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });


    handleFile = async (e, document, url) => {
        let copyDocuments = [...this.state.documents]
        let documents = copyDocuments.map((doc) => {
            if (doc.id === document.id) {
                doc.file = e.target.files[0]
                doc.url = url
                doc.status = (doc.name == document.name) ? this.props.t("uploadIdentityDocument.documents.status.upload") : this.props.t("uploadIdentityDocument.documents.status.pending")
            }
            return doc
        })

        this.setState({
            selectedFile: e.target.files[0],
            selectedFileName: e.target.files[0].name,
            colorBorderContainer: "green",
            documents
        });

        // Upload the base64 in the state
        let fileBase64 = await this.pdfToBase64(e.target.files[0]);
        let pdfBase64 = fileBase64.split(",")[1];
        this.setState({ selectedFileBase64: pdfBase64 });
    };

    handleDeleteFile = (document) => {
        let copyDocuments = [...this.state.documents]
        let documents = copyDocuments.map((doc) => {
            if (doc.id === document.id) {
                doc.status = this.props.t("uploadIdentityDocument.documents.status.pending")
                doc.file = null
                doc.url = ''
            }
            return doc
        })

        this.setState({
            selectedFile: null,
            selectedFileBase64: "",
            colorBorderContainer: "gray",
            documents
        });
        return true;
    };

    uploadIdentityDocument = async () => {
        let ENV = process.env
        let messageError = this.props.t("uploadIdentityDocument.errors.upload.document")
        let documentToSave = {}
        let documents = this.state.documents.filter(doc => doc.file)
        let typeDocumentsRequestIds = this.state.documents.map(doc => doc.clientDocumentTypeRequestId)

        //If exist obligatories documents 
        if (typeDocumentsRequestIds.includes(Number(ENV.REACT_APP_TYPE_DOCUMENT_REQUEST_OBLIGATORY))) {
            let documentsObligatories = this.state.documents.filter(doc => doc.clientDocumentTypeRequestId === Number(ENV.REACT_APP_TYPE_DOCUMENT_REQUEST_OBLIGATORY))
            let pendingDocsObligatory = documentsObligatories.map((doc) => {
                let pendingUploadDoc = (doc.status === this.props.t("uploadIdentityDocument.documents.status.upload")) ? false : true
                return pendingUploadDoc
            })

            //Verify all obligatories documents were upload
            if (pendingDocsObligatory.includes(true)) {
                messageError = this.props.t("uploadIdentityDocument.errors.pending.obligatory.docs")
                this.toggleErrorRequesting(messageError, 4000, false, "/")
                return
            }
        }

        //If exist one or all documents 
        if (typeDocumentsRequestIds.includes(Number(ENV.REACT_APP_TYPE_DOCUMENT_REQUEST_ONE_OR_ALL))) {
            let pendingDocs = this.state.documents.find(doc => doc.status === this.props.t("uploadIdentityDocument.documents.status.upload"))

            //Verify if a document was upload
            if (!pendingDocs) {
                messageError = this.props.t("uploadIdentityDocument.errors.upload.no.file")
                this.toggleErrorRequesting(messageError, 4000, false, "/")
                return
            }

            //Order documents by name
            documents = documents.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

        }

        if (!this.state.selectedFile) {
            messageError = this.props.t("uploadIdentityDocument.errors.upload.no.file")
            this.toggleErrorRequesting(messageError, 4000, false, "/")
            return
        }

        this.toggleLoadingRequesting(true)

        //If documents are more than one select only one
        documentToSave = documents[0]

        if (documentToSave && documentToSave.name && documentToSave.name.includes('*')) {
            let nameSplit = documentToSave.name.split('*')
            documentToSave.name = (nameSplit && nameSplit.length > 0) ? nameSplit[0].trim() : documentToSave.name
        }

        let image = new FormData();
        let file = documentToSave.file
        let clientDocumentId = documentToSave.id
        let signRequestId = this.signRequestId

        image.append("image", file)
        image.append("clientDocumentId", clientDocumentId)
        image.append("signRequestId", signRequestId)
        image.append("solitudeDate", new Date().toISOString())
        try {
            let uploadImage = await this.signerService.uploadIdentityDocumentSigner(image, this.token)
            if (!uploadImage || !uploadImage.data || Number(uploadImage.statusCode) !== 200) {
                if (uploadImage && Number(uploadImage.statusCode) === 410) {
                    messageError = this.props.t("uploadIdentityDocument.errors.upload.user.no.signer")
                    throw new Error(messageError)
                }if (uploadImage && Number(uploadImage.statusCode) === 462) {
                    messageError = this.props.t("uploadIdentityDocument.errors.user.name.not.match")
                    throw new Error(messageError)
                }if (uploadImage && Number(uploadImage.statusCode) === 463) {
                    messageError = this.props.t("uploadIdentityDocument.errors.doc.expired")
                    throw new Error(messageError)
                }if (uploadImage && Number(uploadImage.statusCode) === 450) {
                    messageError = this.props.t("uploadIdentityDocument.errors.cancel.sign.request")
                    throw new Error(messageError)
                } else {
                    throw new Error(messageError)
                }
            }
            const url =  `/detail-signature-sign/${this.signRequestId}`

            this.toggleLoadingRequesting(false)
            this.toggleCompletedRequesting(9000, false, url)
            this.props.getSignatureRequest()
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }

    render() {
        return (
            <UploadIdentityDocumentView
                {...this.props}
                {...this.state}

                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleWarningRequesting={this.toggleWarningRequesting}
                handleFile={this.handleFile}
                handleDeleteFile={this.handleDeleteFile}
                uploadIdentityDocument={this.uploadIdentityDocument}
            />
        )
    }
}

const UploadIdentityDocumentActionContainer = (props) => {
    let { t } = useTranslation()
    return (
        <UploadIdentityDocumentAction
            t={t}
            {...props}
        />
    )
}

export { UploadIdentityDocumentActionContainer as default }